import React, {useState, useContext, useEffect, useRef} from 'react'
import styled, {keyframes} from 'styled-components'
import {Link} from 'gatsby'
import {LinearProgress} from '@material-ui/core'

import {StateContext} from '../../utils/context'
import {_getSimpleDate, _makeCapitalize} from '../../utils/helpers'


export default ({nodes}) => {
  const [datas, setDatas] = useState(nodes)
  const [isLoading, setLoading] = useState(true)
  const context = useContext(StateContext)
  const refLists = useRef([])

  useEffect(() => {
    setLoading(true)
    if (context.state.activeLargeCategory === 'all') setDatas(nodes)
    else {
      if (context.state.activeSmallCategory === 'self') {
        const filtered = nodes.filter((target) => target.frontmatter.category_large === context.state.activeLargeCategory)
        setDatas(filtered)
      } else {
        const filtered = nodes.filter((target) => target.frontmatter.category_large === context.state.activeLargeCategory && target.frontmatter.category_small === context.state.activeSmallCategory)
        setDatas(filtered)
      }
    }
    setLoading(false)
  }, [context.state])

  const addShowFromLeft = (target) => {
    const window_innerHeight = window.innerHeight
    let sTop = target.documentElement.scrollTop
    refLists.current.map((item) => {
      if (item) {
        if (item.offsetTop - window_innerHeight <= sTop + 100) {
          item.classList.add('show-from-scale')
        }
      }
    })
  }

  useEffect(() => {
    addShowFromLeft(document)
    window.addEventListener('scroll', (e) => addShowFromLeft(e.target))
    return () => {
      window.removeEventListener('scroll', (e) => addShowFromLeft(e.target))
    }
  }, [datas])

  return (
    <BlogsContainer>
      {isLoading? <LinearProgress/> : null }
      {datas.map((blog, index) => {
        return (
          <LinkStyled 
            key={blog.fields.slug_path} 
            to={`/blog/${blog.fields.slug_path}`} 
            style={{textDecoration: 'none'}}
            state={{
              large: context.state.activeLargeCategory, 
              small: context.state.activeLargeCategory,
            }}
            
          >
            <BlogList ref={(el) => refLists.current[index] = el}>
              <BlogBackground index={index}/>
              <BlogBox img={blog?.frontmatter?.featuredImage?.childImageSharp?.fluid?.src} index={index}>
                <BlogCategory>{blog.frontmatter.category_small}</BlogCategory>
                <BlogTitle>{blog.frontmatter.title}</BlogTitle>
                <Paragraph>
                  <BlogCreateDate>{_getSimpleDate(blog.frontmatter.date)}</BlogCreateDate>
                  <BlogAuthor>Created by {_makeCapitalize(blog.frontmatter.author)}</BlogAuthor>
                </Paragraph>
              </BlogBox>
            </BlogList>
          </LinkStyled>
        )
      })}
    </BlogsContainer>
  )
}

const fadEffect_from_scale = keyframes`
  from {
    opacity: 0;
    display: none;
    transform: scale(0);
  }
  to {
    opacity: 1;
    display: flex;
    transform: scale(1);
  }
`
const LinkStyled = styled(Link)`
`
const BlogsContainer = styled.div`
  padding-top: 1rem;
  padding-bottom: 1rem;
  width: 100%;
  height: auto;
  @media(min-width: 900px) {
    padding-top: 4rem;
    padding-bottom: 4rem;
    position: relative;
    left: -1rem;
  }
  @media(min-width: 1100px) {
    left: -4rem;
  }
  @media(min-width: 1300px) {
    left: -3rem;
  }
  @media(min-width: 1500px) {
    left: -6rem;
  }
`
const BlogList = styled.div`
  position: relative;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  opacity: 0;
  &.show-from-scale {
    animation: ${fadEffect_from_scale} 0.7s ease-in;
    animation-fill-mode: forwards;
  }
`
const BlogBackground = styled.div`
  position: absolute;
  width: 95%;
  height: 13rem;
  margin: 0 auto;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  margin-bottom: 1rem;
  background-color: ${props => props.index % 2 === 0 ? props.theme.green : props.theme.darkBeige};
  @media(min-width: 900px) {
    width: 95%;
    height: 18rem;
    padding: 1.5rem 4rem;
  }
`
const BlogBox = styled(BlogBackground)`
  position: relative;
  background-color: rgba(0, 0, 0, 0.4);
  background-image: url('${props => props.img ? props.img : null}');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-blend-mode: color;
  @media(min-width: 900px) {
    &:hover {
      background-color: rgba(0, 0, 0, 0.2);
    }
  }
`
const BlogCategory = styled.h4`
  color: #fff;
  font-size: 1.1rem;
  margin-bottom: 0.5rem;
  @media(min-width: 900px) {
    font-size: 2rem;
  }
`
const BlogTitle = styled.h2`
  color: #fff;
  font-size: 1.5rem;
  margin-bottom: 2rem;
  @media(min-width: 900px) {
    font-size: 3rem;
  }
`
const Paragraph = styled.div`
`
const BlogCreateDate = styled.p`
  color: #fff;
  font-size: 0.8rem;
  @media(min-width: 900px) {
    font-size: 1.1rem;
  }
`
const BlogAuthor = styled.p`
  color: #fff;
  font-size: 0.8rem;
  @media(min-width: 900px) {
    font-size: 1.1rem;
  }
`